import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import './css/abonnement.css';

const Abonnement = () => {
    let location = useLocation();
    return (
        <div>
            <Helmet>
                <title>Abonnement </title>
                <meta name='description' content='Abonnement ' />
                <link rel='canonical' href={location.pathname} />
            </Helmet>
            {/* <div className='abonnement'>
                <div className='container'>
                    <div className='bloc_abonnement'>
                        <div className='titre'>
                            <h1><i className='fa fa-newspaper-o'></i>Mes abonnements</h1>
                        </div>
                        <div className='sous_titre'>
                            <h2>Pour rester plus connecté et recevoir les meilleures offres en premier !</h2>
                        </div>
                        <div className='liste_abonnement'>
                            <div className='item_abonnement'>
                                <span className='sous_titre'><i className='fa fa-bolt'></i>  Critère des offres</span>
                                <div className="form-check mt-2">
                                    <input className="form-check-input" type="checkbox" defaultValue id="critère1" />
                                    <label className="form-check-label" htmlFor="critère1">
                                        Notre Newsletter
                                        Sélections de restaurants et d’offres dans votre région
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" defaultValue id="critère2" />
                                    <label className="form-check-label" htmlFor="critère2">
                                        Les offres de nos partenaires
                                        Bons plans sélectionnés pour vous

                                    </label>
                                </div>
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" defaultValue id="critère3" />
                                    <label className="form-check-label" htmlFor="critère3">
                                        [Critère 3]

                                    </label>
                                </div>
                                <div className="form-check mb-3">
                                    <input className="form-check-input" type="checkbox" defaultValue id="critère4" />
                                    <label className="form-check-label" htmlFor="critère4">
                                        [Critère 3]

                                    </label>
                                </div>
                                <span className=' mt-3 remarque'>NB : Vous recevrez dans tous les cas les e-mails / SMS liés à vos réservations ou à la gestion de votre compte, qui ne sont pas gérés par ces abonnements.</span>
                            </div>
                            <div className='item_abonnement '>
                                <span className='sous_titre'><i className='fa fa-bolt'></i> Rythme de réception des offres</span>
                                <div className='mt-2'>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="inlineRadioOptions" id="reception1" defaultValue="option1" />
                                        <label className="form-check-label" htmlFor="reception1">Toutes les offres</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="inlineRadioOptions" id="reception2" defaultValue="option2" />
                                        <label className="form-check-label" htmlFor="reception2">2 fois par semaine</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="inlineRadioOptions" id="reception3" defaultValue="option2" />
                                        <label className="form-check-label" htmlFor="reception3">1 fois par semaine</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="inlineRadioOptions" id="reception4" defaultValue="option2" />
                                        <label className="form-check-label" htmlFor="reception4">Se désabonner</label>
                                    </div>
                                </div>
                            </div>
                            <div className='item_abonnement'>
                                <span className='sous_titre'> <i className='fa fa-bolt'></i> Autre</span>
                                <div className="form-check mt-2">
                                    <input className="form-check-input" type="checkbox" defaultValue id="autre1" />
                                    <label className="form-check-label" htmlFor="autre1">
                                        Autre 1
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" defaultValue id="autre2" />
                                    <label className="form-check-label" htmlFor="autre2">
                                        Autre 2
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" defaultValue id="autre3" />
                                    <label className="form-check-label" htmlFor="autre3">
                                        Autre3

                                    </label>
                                </div>
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" defaultValue id="autre4" />
                                    <label className="form-check-label" htmlFor="autre4">
                                        Autre4

                                    </label>
                                </div>

                            </div>
                            <div className='d-flex justify-content-center'>
                                <button className='btn btn_valider'>Valider</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div> */}
        </div>
    )
}

export default Abonnement